export default "__VITE_ASSET__CoCGGG$H__"